module.exports = __webpack_public_path__ + "/static/assets/c9528ee4be1a12380a6c9caf73bd99e9.svg";